import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { hasAdminAccess } from "@/lib/admin-access";
import { AdminShell } from "@/components/admin/AdminShell";
import { UpcomingInterviewsTable } from "@/components/admin/UpcomingInterviewsTable";

export const Route = createFileRoute("/admin/interview-track")({
  validateSearch: (s: Record<string, unknown>) => ({
    status: typeof s.status === "string" ? s.status : undefined,
  }),
  head: () => ({
    meta: [
      { title: "Interview Track - WeLivdIt Admin" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: AdminInterviewTrackPage,
});


function AdminInterviewTrackPage() {
  const navigate = useNavigate();
  const { status } = Route.useSearch();

  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    (async () => {
      const { data: sess } = await supabase.auth.getSession();
      if (!sess.session) {
        navigate({ to: "/auth", search: { redirect: "/admin/interview-track" } });
        return;
      }
      setAuthorized(await hasAdminAccess(sess.session));
      setLoading(false);
    })();
  }, [navigate]);

  if (loading)
    return (
      <div className="min-h-[60vh] grid place-items-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  if (!authorized)
    return (
      <div className="min-h-[60vh] grid place-items-center px-5">
        <p className="text-muted-foreground">Not authorized.</p>
      </div>
    );

  return (
    <AdminShell
      title="Interview Track"
      description="Every paid student with a scheduled visa interview - send a WhatsApp follow-up with one tap."
    >
      <div className="mt-2">
        <UpcomingInterviewsTable initialStatus={status} />
      </div>
    </AdminShell>
  );
}
